import React from 'react';
import config from '../config';
import Icon from './Icons';
import Reveal from './Reveal';
import './Contact.css';

/** Kontakt: telefón, e-mail, mapa, sociálne siete a WhatsApp. */
export default function Contact() {
  return (
    <section className="section section--gray" id="kontakt">
      <div className="container">
        <Reveal className="section-heading">
          <span className="eyebrow">Kontakt</span>
          <h2>Ozvi sa nám</h2>
          <p className="lead">
            Nie si si istý termínom alebo tým, ako cestovanie v Californii
            funguje? Radi poradíme s výberom termínu, výbavou aj prvou trasou.
          </p>
        </Reveal>

        <div className="contact">
          <Reveal>
            <div className="contact__card">
              <ul className="contact__list">
                <li>
                  <Icon name="phone" size={20} />
                  <a href={`tel:${config.phoneHref}`}>{config.phone}</a>
                </li>
                <li>
                  <Icon name="mail" size={20} />
                  <a href={`mailto:${config.email}`}>{config.email}</a>
                </li>
                <li>
                  <Icon name="pin" size={20} />
                  <span>{config.address}</span>
                </li>
              </ul>

              <a
                className="btn contact__whatsapp"
                href={`https://wa.me/${config.whatsapp.replace(/[^0-9]/g, '')}`}
                target="_blank"
                rel="noreferrer"
              >
                <Icon name="whatsapp" size={20} />
                Napíš nám na WhatsApp
              </a>

              <div className="contact__social">
                <a href={config.social.instagram} target="_blank" rel="noreferrer">
                  Instagram
                </a>
                <a href={config.social.facebook} target="_blank" rel="noreferrer">
                  Facebook
                </a>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="contact__map">
              <iframe
                src={config.mapEmbedUrl}
                title="Mapa – California Košice"
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
